import $ from 'jquery';
import ko from 'knockout';
import { _isFunction } from 'underscore-es/_objects';
import currentScreenSize from '../modules/screen.js';
'use strict';

export function registerComponent() {
  ko.components.register('dropdown-popup', {
    template: { element: 'dropdown-popup-template' },
    viewModel: {
      createViewModel: dropdownPopupViewModel
    }
  });
}

function dropdownPopupViewModel(params, componentInfo) {
  var $window = $(window);
  var $body = $('body');
  var $component = $(componentInfo.element);
  var $popup = $component.find('.dropdown-floating-popup');


  $component.click(function (event) {
    event.stopPropagation();
  });
  $popup.css({
    marginTop: '-' + ($component.height() + 1) + 'px',
    marginLeft: '-1px'
  });

  function dropdownPopupViewModelConstructor(params) {
    var self = this;
    var onOpenEventHandler = null;
    var onCloseEventHandler = null;
    var scrollValue;

    self.cssClass = params.cssClass;
    self.anchor = params.anchor || 'topLeft';
    self.component = params.component.name;
    self.shouldShowPopup = ko.observable(false);
    self.label = ko.observable('');
    self.initParams = params.component.params;

    function handleBodyClick(evt) {
      if (self.shouldShowPopup()) {
        if (_isFunction(onCloseEventHandler)) {
          onCloseEventHandler();
        }
      }
      self.shouldShowPopup(false);
    }

    self.shouldShowPopup.subscribe(function (visible) {
      if (visible) {

        if (self.anchor === 'topRight') {
          // Position it according to the anchor argument.
          if (currentScreenSize() !== 'xs') {
            $popup.css('margin-left', '-' + ($popup.outerWidth() - $component.outerWidth()) + 'px');
          }
        }
        if (_isFunction(onOpenEventHandler)) {
          onOpenEventHandler();
        }

        $body.on('click', handleBodyClick);
      } else {
        $body.off('click', handleBodyClick);
      }
    });

    self.togglePopup = function () {
      if (currentScreenSize() === 'xs') {
        //initialize the scroll value to open the body at where it was earlier
        scrollValue = document.body.scrollTop || document.documentElement.scrollTop;
      }
      if (self.shouldShowPopup() === true) {
        if (_isFunction(onCloseEventHandler)) {
          onCloseEventHandler();
        }
      }
      else if (params.enabled && params.enabled() === false) {
        // Before showing the popup, make sure that it's enabled.
        return;
      }
      if (currentScreenSize() === 'xs') {
        //the datepicker must occupy the fullscreen in mobile view
        $window.scrollTop(0);       
        $('empty-white').show();
        $('.navbar').css({ "z-index": 10000 });
      }
      $('body').addClass('scroll-none');
      self.shouldShowPopup(!self.shouldShowPopup());
    };

    self.close = function () {
      if (_isFunction(onCloseEventHandler)) {
        onCloseEventHandler();
      }
      self.shouldShowPopup(false);
    };

    /**
     * Won't trigger the onCloseEventHandler.
     */
    self.closeImmediately = function () {
      if (currentScreenSize() === 'xs') {
        //reset the body position back to where it was before the popup opened
        $('.mobile-dropdown').css({display: 'none' });
        $window.scrollTop(scrollValue);
      }
      $('body').removeClass('scroll-none');
      self.shouldShowPopup(false);
    };

    self.onOpenEvent = function dropdownPopupAddOpenEventHandler(handlerFn) {
      onOpenEventHandler = handlerFn;
    };

    self.onCloseEvent = function dropdownPopupAddCloseEventHandler(handlerFn) {
      onCloseEventHandler = handlerFn;
    };
  }

  return new dropdownPopupViewModelConstructor(params);
}

/**
 * Initializes all <dropdown-popup> component elements that weren't initialized already.
 */
export function initializeDropdownPopupElements() {
  $('dropdown-popup').each(function () {
    if (!$(this).data('dropdownPopupInitialized')) {
      $(this).data('dropdownPopupInitialized', true);
      ko.applyBindings(null, this);
    }
  });
}